// Always-visible build identifier in the bottom-right corner. Value
// is baked into the client bundle at `vite build` time via the
// VITE_APP_VERSION build-arg in .woodpecker/maisons.yml — either the
// git semver tag (e.g. "v0.1.0") or a 7-char commit SHA fallback.
// Local `pnpm dev` builds default to "dev".
export function VersionPill() {
  const version = import.meta.env.VITE_APP_VERSION ?? "dev";
  return (
    <div
      className="pointer-events-none fixed bottom-2 right-2 z-40 select-none"
      aria-hidden="true"
    >
      <span className="rounded-md border border-slate-200 bg-white/80 px-2 py-0.5 font-mono text-[10px] font-medium uppercase tracking-wider text-slate-500 shadow-sm backdrop-blur">
        {version}
      </span>
    </div>
  );
}
